import {combineReducers} from 'redux';

import auth from './auth';
import sp from './sp';
import logout from './logout';

const rootReducer = combineReducers({
  auth,
  sp,
  logout,
});
export default rootReducer;
